import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class FlipAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const top = item.y - 150;
        const bottom = item.y;
        const duration = this.time || 0.6;
        const sx = item.scale.x;
        const sy = item.scale.y;
        const r = item.rotation;
        const appear = this.appear && this.delay;
        item.tweenFrom(duration * 0.1, Ease.sineInOut, {
            scaleX: sx * 0.1,
            scaleY: sy * 0.1,
            delay: this.delay,
            onStart: appear ? () => {
                item.paperCutVisible(true);
                item.alpha = 1;
            } : undefined,
            onUpdate: () => this.updatePaperCut(item),
            onComplete: () => {
                item.tweenTo(duration * 0.4, Ease.sineOut, {
                    y: top,
                    scaleX: sx * 1.1,
                    scaleY: sy * 1.1,
                    rotation: r + Math.PI,
                    onUpdate: () => this.updatePaperCut(item),
                    onComplete: () => {
                        item.tweenTo(duration * 0.3, Ease.sineIn, {
                            y: bottom,
                            scaleX: sx,
                            scaleY: sy,
                            rotation: r + Math.PI * 2,
                            onUpdate: () => this.updatePaperCut(item),
                            onComplete: () => {
                                const bounds = item.getLocalBounds();
                                item.tweenTo(duration * 0.1, Ease.sineInOut, {
                                    y: bottom + (bounds.height + bounds.y) * sy * 0.1,
                                    scaleY: sy * 0.9,
                                    repeat: 1,
                                    yoyo: true,
                                    onUpdate: () => this.updatePaperCut(item),
                                    onComplete: () => {
                                        this.onComplete();
                                        cb();
                                    },
                                });
                            },
                        });
                    },
                });
            },
        });
        if (appear) {
            item.alpha = 0;
            item.paperCutVisible(false);
        } else if (this.delay) {
            this.updatePaperCut(item);
        }
    }
}
